(() => {
  if (!HTMLScriptElement.supports?.('speculationrules') || navigator.connection?.saveData || /(^|-)2g$/.test(navigator.connection?.effectiveType || '')) return;
  const prefix = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  const origin = window.location.origin;
  const rules = document.createElement('script');
  rules.type = 'speculationrules';
  rules.textContent = JSON.stringify({prefetch: [{source: 'document', eagerness: 'moderate', where: {and: [{or: [{href_matches: origin + prefix + 'products/*'}, {href_matches: origin + prefix + 'collections/*'}]}, {not: {selector_matches: '[href*="?"], [href*="#"], [download], [target="_blank"], [data-no-prefetch]'}}]}}]});
  document.head.append(rules);
})();
